<template>
    <div class="v-cloak--hidden" v-if="episode || user.contributer">
        <div id="movie-info__wrapper">
            <div class="block movie-poster__box">
                <router-link :to="{ name: 'serial-detail', params: { slug: serialSlug }}">
                    <img :src="baseUrl + episode.serial_poster" class="rounded" width="300"/>
                </router-link>
                <v-dialog v-model="commentDialog" max-width="640" min-width="320">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn block class="movie-review__dlg_btn" v-bind="attrs" v-on="on">
                            <span v-show="grade"><v-rating :value="parseInt(grade) * 0.05" color="#FFF" length="5" :empty-icon="emptyIcon" :full-icon="fullIcon" :half-icon="halfIcon" half-increments readonly size="20"></v-rating></span>
                            <span v-show="!grade" class="movie-review__dlg_btn_txt">Үнэлгээ</span>
                        </v-btn>
                    </template>
                    <template v-slot:default="commentDialog">
                        <v-card>
                            <div v-if="user.isAuthenticated">
                                <v-tabs v-model="commentTab" fixed-tabs>
                                    <v-tabs-slider></v-tabs-slider>
                                    <v-tab href="#tabs-5-1" class="primary--text"><v-icon>mdi-comment</v-icon></v-tab>
                                    <v-tab href="#tabs-5-2" class="primary--text"><v-icon>mdi-heart</v-icon></v-tab>
                                    <v-tab href="#tabs-5-3" class="text font-weight-bold" v-if="user.critic && reviewCheck">Шүүмж</v-tab>
                                </v-tabs>
                                <v-tabs-items v-model="commentTab">
                                    <v-tab-item :key="1" value="tabs-5-1">
                                        <div class="ma-3 pa-3" max-width="640" min-width="320">
                                            <div v-if="errors.length" class="movie-review__error"><p v-for="(error, index) in errors" :key="index">{{ error }}</p></div>
                                            <v-form ref="form" v-on:submit.prevent="submitReview(loadReview = true)">
                                                <div class="movie-review__grade_box">
                                                    <div class="movie-review__grade_txt_block">
                                                        <v-text-field class="movie-review__grade_txt_field" outlined v-model="grade" name="grade" type="number" min="0" label="Тоон үнэлгээ" hint="Та 0-100 хооронд тоо оруулна уу!" required></v-text-field>
                                                    </div>
                                                    <div class="movie-review__grade_slider_block">
                                                        <div class="movie-review__grade_slider">
                                                            <v-slider class="movie-review__grade_slider_style" v-model="grade" min="0" max="100"></v-slider>
                                                            <v-rating :value="parseInt(grade) * 0.05" color="#0066b5" length="5" :empty-icon="emptyIcon" :full-icon="fullIcon" :half-icon="halfIcon" half-increments readonly size="28"></v-rating>
                                                        </div>
                                                    </div>
                                                </div>
                                                <v-textarea outlined v-model="review" name="review" label="Үгэн үнэлгээ" hint="Та 500 тэмдэгтэнд багтааж бичнэ үү!"></v-textarea>
                                                <v-checkbox v-model="spoilerCheckBox" label="Миний сэтгэгдэл үйл явдлын ИЛЧЛЭЛТ агуулсан"></v-checkbox>
                                                <v-card-actions class="justify-center">
                                                    <v-dialog v-model="reviewDeleteDialog" persistent max-width="290">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn v-if="grade" depressed color="red" width="33%" dark v-bind="attrs" v-on="on" class="ma-1">устгах</v-btn>
                                                        </template>
                                                        <v-card>
                                                            <v-spacer></v-spacer>
                                                            <v-card-text class="pa-2 movie-review__delete_txt">Та өөрийн үлдээсэн үнэлгээг устгах гэж байна.</v-card-text>
                                                            <v-card-actions>
                                                                <v-spacer></v-spacer>
                                                                <v-btn color="red darken-1" text @click="reviewDeleteDialog = false; deleteReview();">УСТГАХ</v-btn>
                                                                <v-btn color="blue darken-1" text @click="reviewDeleteDialog = false">БУЦАХ</v-btn>
                                                            </v-card-actions>
                                                        </v-card>
                                                    </v-dialog>
                                                    <v-btn dark color="green" depressed width="33%" type="submit">Хадгалах</v-btn>
                                                </v-card-actions>
                                            </v-form>
                                        </div>
                                    </v-tab-item>
                                    <v-tab-item :key="2" value="tabs-5-2">
                                        <div class="ma-3 pa-3" max-width="840" min-width="320">
                                            <v-btn-toggle outlined color="#FFF" class="movie_reaction__box">
                                                <v-menu offset-y>
                                                    <template v-slot:activator="{ attrs, on }">
                                                        <v-btn color="#FFF" v-bind="attrs" v-on="on" class="movie_reaction__btn">{{ episodeReact1 }}</v-btn>
                                                    </template>
                                                    <v-list>
                                                        <v-list-item-content class="text-center">
                                                            <v-list-item-title>Episode reactions <v-btn v-show="episodeReact1" color="red darken-1" icon plain text @click="episodeReact(1, null)"><v-icon>mdi-trash-can</v-icon></v-btn></v-list-item-title>
                                                        </v-list-item-content>
                                                        <v-divider></v-divider>
                                                        <v-list-item v-for="(item, index) in reactions" :key="index" link>
                                                            <v-list-item-title @click="item.check ? null : episodeReact(1, item)" :class="[item.check ? 'movie_reaction__check' : null]">{{ item.emoji }} - {{ item.name }}</v-list-item-title>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-menu>
                                                <v-menu offset-y>
                                                    <template v-slot:activator="{ attrs, on }">
                                                        <v-btn color="#FFF" v-bind="attrs" v-on="on" class="movie_reaction__btn">{{ episodeReact2 }}</v-btn>
                                                    </template>
                                                    <v-list>
                                                        <v-list-item-content class="text-center">
                                                            <v-list-item-title>Episode reactions <v-btn v-show="episodeReact2" color="red darken-1" icon plain text @click="episodeReact(2, null)"><v-icon>mdi-trash-can</v-icon></v-btn></v-list-item-title>
                                                        </v-list-item-content>
                                                        <v-divider></v-divider>
                                                        <v-list-item v-for="(item, index) in reactions" :key="index" link>
                                                            <v-list-item-title @click="item.check ? null : episodeReact(2, item)" :class="[item.check ? 'movie_reaction__check' : null]">{{ item.emoji }} - {{ item.name }}</v-list-item-title>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-menu>
                                                <v-menu offset-y>
                                                    <template v-slot:activator="{ attrs, on }">
                                                        <v-btn color="#FFF" v-bind="attrs" v-on="on" class="movie_reaction__btn">{{ episodeReact3 }}</v-btn>
                                                    </template>
                                                    <v-list>
                                                        <v-list-item-content class="text-center">
                                                            <v-list-item-title>Episode reactions <v-btn v-show="episodeReact3" color="red darken-1" icon plain text @click="episodeReact(3, null)"><v-icon>mdi-trash-can</v-icon></v-btn></v-list-item-title>
                                                        </v-list-item-content>
                                                        <v-divider></v-divider>
                                                        <v-list-item v-for="(item, index) in reactions" :key="index" link>
                                                            <v-list-item-title @click="item.check ? null : episodeReact(3, item)" :class="[item.check ? 'movie_reaction__check' : null]">{{ item.emoji }} - {{ item.name }}</v-list-item-title>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-menu>
                                            </v-btn-toggle>
                                            <!-- <v-btn height="42px" color="#0066b5" v-show="user.isAuthenticated" @click="favoriteUser" x-small outlined class="mx-1"><v-icon>{{ userFavorite ? 'mdi-star' : 'mdi-star-outline' }}</v-icon></v-btn>
                                            <v-btn height="42px" color="#0066b5" v-show="user.isAuthenticated && userWatched" x-small outlined class="mx-1"><v-icon>mdi-check</v-icon></v-btn> -->
                                            
                                            <!-- <v-btn height="42px" color="#0066b5" @click="favoriteUser" x-small outlined class="mx-1 ma-1"><v-icon>{{ userFavorite ? 'mdi-star' : 'mdi-star-outline' }}</v-icon>миний дуртай кино</v-btn>
                                            <v-btn height="42px" color="#0066b5" v-show="userWatched" x-small outlined class="mx-1 ma-1"><v-icon>mdi-check</v-icon> миний үзсэн кино</v-btn>
                                            <v-btn height="42px" color="#0066b5" v-show="!userWatch && !userWatched" @click="watchUser" x-small outlined class="mx-1"><v-icon>mdi-plus</v-icon> үзэх кинонд нэмэх</v-btn>
                                            <v-btn height="42px" color="#0066b5" v-show="userWatching && movie.runtime" @click="watchingUser" x-small outlined class="mx-1"><v-icon>mdi-eye</v-icon></v-btn> -->
                                        </div>
                                    </v-tab-item>
                                    <v-tab-item :key="3" value="tabs-5-3">
                                        <div class="ma-2 pa-2 text-center font-weight-bold" max-width="840" min-width="320">
                                            <div>{{ episode.e_title }} -д тойм шүүмж бичих</div>
                                            <v-spacer></v-spacer>
                                            <div class="d-flex flex-column pa-2">
                                                <div v-if="detailedReviewErrors.length" class="movie_detailed_review__error">
                                                    <p v-for="(error, index) in detailedReviewErrors" :key="index">{{ error }}</p>
                                                </div>
                                                <v-text-field v-model="reviewTitle" label="Гарчиг*" required></v-text-field>
                                                <tinymceEditor api-key="dh9tjnxmzhiub2bx0brpetqavxuw7z518330gl5p1kn1ivy6" v-model="detailedReview" :init="customToolbar"/>
                                            </div>
                                            <v-dialog v-model="detailedReviewDeleteDialog" persistent max-width="290">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn v-if="detailedReview" dark depressed color="red" v-bind="attrs" v-on="on" class="movie_detailed_review__delete_btn">Устгах</v-btn>
                                                </template>
                                                <v-card>
                                                    <v-spacer></v-spacer>
                                                    <v-card-text class="pa-2 movie_detailed_review__delete_txt">Та өөрийн үлдээсэн тойм шүүмжийг устгах гэж байна.</v-card-text>
                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn class="ma-1" color="red darken-1" text @click="detailedReviewDeleteDialog = false; deleteDetailedReview();">УСТГАХ</v-btn>
                                                        <v-btn color="blue darken-1" text @click="detailedReviewDeleteDialog = false">БУЦАХ</v-btn>
                                                    </v-card-actions>
                                                </v-card>
                                            </v-dialog>
                                            <v-btn dark depressed @click="submitDetailedReview(loadDetailedReview = true);" color="green" width="33%">Хадгалах</v-btn>
                                        </div>
                                    </v-tab-item>
                                </v-tabs-items>
                            </div>
                            <div v-else>
                                <v-container class="text-center">
                                    <div class="movie_review__login_txt">Та үнэлгээ өгөхийн тулд <span class="movie_review__login_link" @click="loginRequired()">НЭВТЭРНЭ</span> үү!</div>
                                </v-container>
                            </div>
                            <v-card-actions class="justify-end"><v-btn text @click="commentDialog.value = false" color="#0066b5">Хаах</v-btn></v-card-actions>
                        </v-card>
                    </template>
                </v-dialog>
                <div class="text-no-wrap mt-5 mb-5 d-flex justify-space-between">
                    <v-btn class="next_episode" text small @click="previousEpisode()" :disabled="episode.previous_episode === null">
                        &lt; өмнөх анги
                    </v-btn>
                    <v-btn class="next_episode" text small @click="nextEpisode()" :disabled="episode.next_episode === null">
                        дараагийн анги &gt;
                    </v-btn>
                </div>
                
            </div>
            <div class="block movie-background__box">
                <img class="movie-background__image" :src="baseUrl + episode.background"/>
                <div v-show="episode.ser_title || episode.e_title" class="movie-background__block">
                    <div class="movie-background__title">{{ episode.ser_title }}</div>
                    <div class="movie-background__year">{{ episode.e_title }}</div>
                </div>
            </div>
            <div class="block movie-info__box">
                <div v-show="episode.grade || episode.a_grade" class="movie-grade">
                    <v-card elevation="3">
                        <div class="movie-grade__box">
                            <div @click="gotoId(1)" v-show="episode.grade" :class="episode.grade && episode.a_grade ? 'movie-grade__block movie-grade__block__divider' : 'movie-grade__block'">
                                <div class="movie-grade__critic">{{ episode.grade }}%</div>
                                <div class="movie-grade__rate">
                                    <v-rating :value="parseInt(episode.grade) * 0.05" color="#B29600" background-color="#B29600" length="5" :empty-icon="emptyIcon" :full-icon="fullIcon" :half-icon="halfIcon" dense half-increments readonly size="32"></v-rating>
                                    {{ episode.critics }} шүүмжлэгч
                                </div>
                            </div>
                            <div @click="gotoId(2)" v-show="episode.a_grade" class="movie-grade__block">
                                <div class="movie-grade__audience">{{ episode.a_grade }}%</div>
                                <div class="movie-grade__rate">
                                    <v-rating :value="parseInt(episode.a_grade) * 0.05" color="#0066b5" background-color="#0066b5" length="5" :empty-icon="emptyIcon" :full-icon="fullIcon" :half-icon="halfIcon" dense half-increments readonly size="32"></v-rating>
                                    {{ episode.audiences }} кино сонирхогч
                                </div>
                            </div>
                        </div>
                    </v-card>
                </div>
                <div class="movie-info__title_m" v-show="episode.ser_title">{{ episode.ser_title }}</div>
                <div class="movie-info__title_io" v-show="episode.sea_title">{{ episode.sea_title }}</div>
                <div class="episode-number_io" v-show="episode.e_num">{{ episode.e_num }}-р анги</div>
                <div class="movie-info__title_io" v-show="episode.e_title">{{ episode.e_title }}</div>
                <div class="movie-info__block">
                    <small>
                        <span v-show="episode.runtime" class="movie-info__fltr"><v-icon class="movie-info__icon">mdi-clock-time-three</v-icon> {{ episode.runtime }}'</span>
                    </small>
                </div>
                <div class="movie-info__block">
                    <span class="movie-info__plot">{{ episode.plot ? episode.plot : episode.eng_plot }}</span>
                </div>
            </div>
        </div>
        <div class="movie-content">
            <div class="movie-content__box">
                <div class="movie-review__block">
                    <legend class="movie-review__legendbar"><strong >Үнэлгээ:</strong></legend>
                    <v-tabs v-model="activeTab" color="light-blue darken-3 accent-4" fixed-tabs width="100%">
                        <v-tab @click="criticsCall" id="critics">шүүмжлэгчид</v-tab>
                        <v-tab @click="audiencesCall" id="audiences">сонирхогчид</v-tab>
                        <v-tab-item :key="1">
                            <v-container fluid>
                                <GenericReviewers :type="'episode'" :reviewer="'critic'" :serialSlug="serialSlug" :seasonSlug="seasonSlug" :episodeSlug="currentEpisodeSlug" ref="criticRef"/>
                            </v-container>
                        </v-tab-item>
                        <v-tab-item :key="2">
                            <v-container fluid>
                                <GenericReviewers :type="'episode'" :reviewer="'audience'" :serialSlug="serialSlug" :seasonSlug="seasonSlug" :episodeSlug="currentEpisodeSlug" ref="audienceRef"/>
                            </v-container>
                        </v-tab-item>
                    </v-tabs>
                </div>
            </div>
        </div>
        <div v-if="user.isAuthenticated && user.contributer && user.adminBarHide" class="subadmin__box">
            <v-dialog v-model="publishDialog" width="500">
                <template v-slot:activator="{ on, attrs }">
                    <button :class="publish ? 'subadmin__publish' : 'subadmin__unpublish'" v-bind="attrs" v-on="on" ><v-icon class="subadmin__icon">mdi-clipboard-check-outline</v-icon></button>
                </template>
                <v-card>
                    <v-card-title class="headline grey lighten-2 mx-auto">Анги нийтлэх</v-card-title>
                    <v-card-text class="mt-3">Та "{{ episode.ser_title }}" <span v-if="publish">ангийн нийтлэгдснийг болиулах</span><span v-else>ангийг нийтлэх</span> гэж байна!</v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn :color="publish ? 'red' : 'primary'" text @click="publishDialog = false; publishEpisode();">{{publish ? "болиулах" : "нийтлэх"}}</v-btn>
                        <v-btn color="warning" text @click="publishDialog = false">буцах</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <router-link class="subadmin__update" :to="{name: 'episode-update', params: {serialSlug: serialSlug, seasonSlug: seasonSlug, episodeSlug: currentEpisodeSlug}}"><v-icon class="subadmin__icon">mdi-lead-pencil</v-icon></router-link>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Editor from '@tinymce/tinymce-vue'

import GenericReviewers from '@/views/generics/movie_serial/GenericReviewerList.vue'

export default {
    props: {
        serialSlug: String,
        seasonSlug: String,
        episodeSlug: String
    },
    components: {
        GenericReviewers,
        'tinymceEditor': Editor
    },
    data(){
        return{
            currentEpisodeSlug: this.episodeSlug,
            commentDialog: false,
            commentTab: null,
            baseUrl: process.env.VUE_APP_BASEURL,
            episode: {},
            publish: '',
            seasonEpisodes: [],
            activeTab: 0,
            emptyIcon: 'mdi-star-outline',
            fullIcon: 'mdi-star',
            halfIcon: 'mdi-star-half-full',
            publishDialog: false,
            errors: [],
            grade: '',
            review: '',
            reviewTitle: '',
            reviewCheck: false,
            reviewDeleteDialog: false,
            loadReview: '',
            detailedReview: '',
            detailedReviewCover: null,
            detailedReviewCoverURL: null,
            detailedReviewDeleteDialog: false,
            detailedReviewErrors: [],
            userWatched: false,
            userWatching: false,       
            customToolbar: {
                height: 500,
                contextmenu: 'link image table',
                content_style: 'img {max-width: 800px;}',
                menu : {
                    file: {title: 'File', items: 'newdocument restoredraft | preview | print | deleteallconversations'},
                    edit: {title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall | searchreplace'},
                    view: {title: 'View', items: 'code | visualaid visualchars visualblocks | spellchecker | fullscreen | showcomments'},
                    insert: {title: 'Insert', items: 'image link media addcomment pageembed template codesample inserttable | charmap emoticons hr | pagebreak nonbreaking anchor toc | insertdatetime'},
                    format: {title: 'Format', items: 'bold italic underline strikethrough superscript subscript codeformat | formats blockformats fontsizes align | forecolor backcolor | removeformat'},
                    tools: {title: 'Tools', items: 'spellchecker spellcheckerlanguage | a11ycheck code wordcount'},
                    table: {title: 'Table', items: 'inserttable | cell row column | advtablesort | tableprops deletetable'}
                },
                images_file_types: 'jpg, jpeg',
                images_upload_handler: this.uploadContentImage,
                plugins: ['advlist autolink lists link image charmap print preview anchor searchreplace visualblocks fullscreen insertdatetime media table paste wordcount imagetools'],
                toolbar: 'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat'
            },
            spoilerCheckBox: false,
            reviewFormExpand: false,
            userReactions: null,
            episodeReact1: '?',
            episodeReactText1: '',
            episodeReact2: '?',
            episodeReactText2: '',
            episodeReact3: '?',
            episodeReactText3: '',
            reactions: [
	            { name: 'Миний "guilty pleasure"', "emoji": "💙", text: "guilty_pleasure", check: false },
                { name: "Киночдын гарын авлага болхуйц кино", "emoji": "📝", text: "movie_guide", check: false },
                { name: "Киноны хөгжим нь маш их таалагдлаа", "emoji": "🎵", text: "awesome_music", check: false },
                { name: "Найруулагчийн төгс ажил", "emoji": "📣", text: "top_notch_directing", check: false },
                { name: "Жүжигчид нь маш сайн тогложээ", "emoji": "🎭", text: "top_notch_act", check: false },
                { name: "Зураг авалт нь төгс болжээ", "emoji": "🎥", text: "top_notch_cinematography", check: false },
                { name: "Сайн кино болжээ, БРАВО!!!", "emoji": "👏", text: "bravo", check: false },
                { name: "Киноны мөч бүхэн таалагдлаа", "emoji": "😍", text: "loved_every_minute", check: false },
                { name: "Дундуур нь унтсан", "emoji": "💤", text: "i_slept", check: false },
                { name: "Шоконд орсон", "emoji": "😳", text: "i_shocked", check: false },
                { name: "Traumatized", "emoji": "😵", text: "i_traumatized", check: false },
                { name: "Хүлээлтэд хүрсэнгүй", "emoji": "😞", text: "i_am_dissapointed", check: false },
                { name: "Яахавдээ л санадлаа", "emoji": "😒", text: "i_am_not_amused", check: false },
                { name: "Үнэхээр хөгжилтэй санагдлаа", "emoji": "😆", text: "it_was_funny", check: false },
                { name: "Маш гунигтай санагдлаа", "emoji": "😢", text: "it_was_sad", check: false },
                { name: "Маш их айлаа", "emoji": "😱", text: "i_was_scared", check: false },
	            { name: "Mind blown", "emoji": "🤯", text: "it_was_mind_blown", check: false }
	        ],
            reactStyle: {
                'margin': '0 -0.4em',
                'padding': '0.1em 0.4em',
                'border-radius': '0.8em 0.3em',
                'background': 'transparent',
                'background-image': 'linear-gradient(to right, rgba(255, 225, 0, 0.1), rgba(255, 225, 0, 0.7) 4%, rgba(255, 225, 0, 0))',
                '-webkit-box-decoration-break': 'clone',
                'box-decoration-break': 'clone'
            }
        }
    },
    computed: mapState(['user']),
    methods:{
        gotoId(a){
            var b
            a === 1 ? (b = "critics", this.activeTab = 0) : (b = "audiences", this.activeTab = 1)

            var el = document.getElementById(b)
            if(typeof el !== "undefined" && el !== null) {
                document.getElementById(b).scrollIntoView({ behavior: "smooth" })
            }
        },
        uploadContentImage(blobInfo, success){
            var image = blobInfo.blob()
            if(image['type']==='image/jpeg'){
                var formData = new FormData()
                formData.append("image", image, "content-image")

                axios
                    .post('/user/api/v-user-useraddimage/', formData)
                    .then(result => {
                        const url = result.data.url
                        success(url)
                    })
                    .catch(err => {
                    })
            } else {
                this.$store.commit('SET_SNACK', {message: 'Та JPEG өргөтгөлтэй зураг оруулна уу!', color: 'red'})
            }
        },
        onCoverSelected(event){
            if(event && event['type']==='image/jpeg'){
                this.detailedReviewCover = event
                this.detailedReviewCoverURL = window.URL.createObjectURL(event)
            } else {
                this.$store.commit('SET_SNACK', {message: 'Та JPEG өргөтгөлтэй зураг оруулна уу!', color: 'red'})
            }
        },
        changeCheck(text, boolean){
            for (var i in this.reactions) {
                if (this.reactions[i].text == text) {
                    this.reactions[i].check = boolean
                    break
                }
            }
        },
        setReaction(episodeReact, reaction){
            if(reaction){
                let result = this.reactions.find(x => x.text === reaction)
                if (result) {
                    if(episodeReact === 1) this.episodeReact1 = result.emoji, this.episodeReactText1 = result.text
                    else if(episodeReact === 2) this.episodeReact2 = result.emoji, this.episodeReactText2 = result.text
                    else if(episodeReact === 3) this.episodeReact3 = result.emoji, this.episodeReactText3 = result.text
                    this.changeCheck(result.text, true)
                }
            }
        },
        episodeReact(id, item){
            let emoji = '?', text = ''
            if(item !== null) emoji = item.emoji, text = item.text, this.changeCheck(item.text, true)

            if(id === 1) this.changeCheck(this.episodeReactText1, false), this.episodeReact1 = emoji, this.episodeReactText1 = text
            else if(id === 2) this.changeCheck(this.episodeReactText2, false), this.episodeReact2 = emoji, this.episodeReactText2 = text
            else if(id === 3) this.changeCheck(this.episodeReactText3, false), this.episodeReact3 = emoji, this.episodeReactText3 = text

            axios
                .post('/serial/api-episode-react/', { serial: this.serialSlug, season: this.seasonSlug, episode: this.currentEpisodeSlug, react: id, reaction: '' })
        },
        getEpisodeDetail(){
            axios
                .get('/serial/api-episode-detail/', {params: {serialSlug: this.serialSlug, seasonSlug: this.seasonSlug, episodeSlug: this.currentEpisodeSlug}})
                .then(response => { this.episode = response.data.episode_detail,
                                    document.title = this.episode['e_title'],
                                    this.publish = this.episode.publish,
                                    this.userWatched = response.data.user_watched,
                                    this.userWatching = response.data.user_watching,
                                    this.userReactions = response.data.user_reactions })
                .catch(error => { if(error.response.status === 404){ this.$router.push({ name: 'not-found-404'}) }})
        },
        publishEpisode(){
            if(this.user.isAuthenticated){
                if(this.publish == false){
                    this.publish = true
                } else{
                    this.publish = false
                }
                axios
                    .post('/serial/api-publish-episode/', {serialSlug: this.serialSlug, seasonSlug: this.seasonSlug, episodeSlug: this.currentEpisodeSlug})
            }
        },
        submitReview(load){
            if (this.user.isAuthenticated) {
                this.errors = []

                if(this.grade == '' && this.loadReview){
                    this.errors.push("Та тоон үнэлгээ заавал оруулах шаардлагатай!")
                } else if((this.grade < 0 || this.grade > 100) && this.loadReview){
                    this.errors.push("Та тоон үнэлгээгээ зөв оруулна уу!")
                }

                if(!this.errors.length){
                    this.commentDialog = false
                    axios
                        .post('/serial/api-submit-episode-review/', {grade: this.grade, review: this.review, serialSlug: this.serialSlug, seasonSlug: this.seasonSlug, episodeSlug: this.currentEpisodeSlug, spoiler: this.spoilerCheckBox, load: load})
                        .then(response => {this.grade = response.data.grade, this.spoilerCheckBox = response.data.spoiler, this.review = response.data.review, this.reviewCheck = response.data.review_check, this.reviewFormExpand = false})
                }
            }
        },
        deleteReview(){
            axios
                .post('/serial/api-delete-episode-review/', {serialSlug: this.serialSlug, seasonSlug: this.seasonSlug, episodeSlug: this.currentEpisodeSlug})
            this.grade = ''
            this.review = ''
        },
        submitDetailedReview(load){
            if (this.user.isAuthenticated && this.user.critic) {
                const createItems = {
                    'serialSlug': this.serialSlug,
                    'seasonSlug': this.seasonSlug,
                    'episodeSlug': this.currentEpisodeSlug,
                    'title': this.reviewTitle,
                    'review': this.detailedReview,
                    'load': load
                }

                const createData = new FormData()

                if(this.detailedReviewCover){
                    createData.append('cover', this.detailedReviewCover, this.detailedReviewCover.name)
                }

                for(var key in createItems){
                    createData.append(key, createItems[key])
                }

                if(!this.detailedReviewErrors.length){
                    this.commentDialog = false
                    axios
                        .post('/serial/api-submit-episode-detailed-review/', createData)
                        .then(response => {this.reviewTitle = response.data.title, this.detailedReview = response.data.review, this.detailedReviewCoverURL = this.url + response.data.cover})
                }
            }
        },
        deleteDetailedReview(){
            axios
                .post('/serial/api-delete-episode-detailed-review/', {serialSlug: this.serialSlug, seasonSlug: this.seasonSlug, episodeSlug: this.currentEpisodeSlug})
            this.reviewTitle = ''
            this.detailedReview = ''
            this.detailedReviewCoverURL = null
        },
        criticsCall(){
            this.$nextTick(() => {
                if(this.$refs.criticRef){
                    this.$refs.criticRef.totalReviews = []
                    this.$refs.criticRef.movieReviews = []
                    this.$refs.criticRef.movieReview()
                }
            })
        },
        audiencesCall(){
            this.$nextTick(() => {
                if(this.$refs.audienceRef){
                    this.$refs.audienceRef.totalReviews = []
                    this.$refs.audienceRef.movieReviews = []
                    this.$refs.audienceRef.movieReview()
                }
            })
        },
        loginRequired(){
            if(!this.user.isAuthenticated) {
                this.$router.push({ name: 'login', query: { redirect:  { name: 'episode-detail', params: { serialSlug: this.serialSlug, seasonSlug: this.seasonSlug, episodeSlug: this.currentEpisodeSlug }}}})
            }
        },
        previousEpisode(){
            this.currentEpisodeSlug = this.episode.previous_episode
            this.$router.push({ name: 'episode-detail', params: { serialSlug: this.serialSlug, seasonSlug: this.seasonSlug, episodeSlug: this.episode.previous_episode }})
        },
        nextEpisode(){
            this.currentEpisodeSlug = this.episode.next_episode
            this.$router.push({ name: 'episode-detail', params: { serialSlug: this.serialSlug, seasonSlug: this.seasonSlug, episodeSlug: this.episode.next_episode }})
            
        }
    },
    watch: {
        currentEpisodeSlug(){
            window.scrollTo(100,100)
            this.getEpisodeDetail()
            this.submitReview(this.loadReview = false)
            this.submitDetailedReview(this.loadDetailedReview = false)
            this.userReactions = null
            this.episodeReact1 = '?'
            this.episodeReactText1 = ''
            this.episodeReact2 = '?'
            this.episodeReactText2 = ''
            this.episodeReact3 = '?'
            this.episodeReactText3 = ''
            for (var i in this.reactions) {
                this.reactions[i].check = false
            }
        },
        userReactions(){
            if(this.userReactions !== null){
                this.setReaction(1, this.userReactions['react1'])
                this.setReaction(2, this.userReactions['react2'])
                this.setReaction(3, this.userReactions['react3'])
            }
        }
    },
    created(){
        this.getEpisodeDetail()
        this.submitReview(this.loadReview = false)
        this.submitDetailedReview(this.loadDetailedReview = false)
    }
}
</script>

<style scoped src="@/assets/styles/movie_serial.css">
</style>